import { render, staticRenderFns } from "./ioc-transfer.vue?vue&type=template&id=04af35c5&"
import script from "./ioc-transfer.vue?vue&type=script&lang=js&"
export * from "./ioc-transfer.vue?vue&type=script&lang=js&"
import style0 from "./ioc-transfer.vue?vue&type=style&index=0&id=04af35c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports